import React, {FC, useEffect, useState} from 'react';

import {connect} from 'react-redux';

import {useFeatureWithAnalytics} from 'components/feature';
import {ApplicationStoreType} from 'desktop/store';

import {useCheckLuxuryItem} from 'hooks/useCheckLuxuryItem/useCheckLuxuryItem';
import {flags} from 'libs/rollout';

import {changeSuccessScreen} from '../../store/actions/orderItems/orderItems';
import {
    FILL_DR_DETAILS_OR_UPLOAD_FILE,
    YOU_WILL_RECEIVE_A_CONFIRMATION,
} from '../../store/reducers/orderItems/constants';
import {
    getStatus,
    getSuccessPageItems,
    getSuccessScreen,
    isOrderContainsSubscriptionItems,
} from '../../store/selectors/orderItems/orderItems';
import {SuccessScreenType} from '../../types/orderItemsTypes';
import {ConfirmButtonConnected} from '../confirmButton/confirmButton';
import {DrDetailsOrUploadFileRedesignItemsConnected} from '../drDetailsOrUploadFileRedesignItems/drDetailsOrUploadFileRedesignItems';
import {ReorderPopupSuccessPageConnected} from '../reorderPopupSuccessPage/reorderPopupSuccessPage';
import {SendLaterSuccessButtonConnected} from '../sendLaterSuccessButton/sendLaterSuccessButton';
import {SuccessMessageConnected} from '../successMessage/successMessage';

import s from './successContactLenses.scss';

export type PropsType = {
    screen: SuccessScreenType;
    itemsLength: boolean;
    changeScreen: (screen: SuccessScreenType) => void;
    isSubscriptionItems: boolean;
};

/**
 * Container on CL success page
 * @returns {React.ReactElement} Rendered react component
 */
export const SuccessContactLenses: FC<PropsType> = ({
    changeScreen,
    isSubscriptionItems,
    itemsLength,
    screen,
}) => {
    const isLuxuryEnabled = useCheckLuxuryItem(flags.dLuxurySpecialExperience.isEnabled());
    const [isModalOpen, setModalOpen] = useState(false);
    useFeatureWithAnalytics('dTYPContacts', false, 'desktop');

    useEffect(() => {
        if (!itemsLength) changeScreen(YOU_WILL_RECEIVE_A_CONFIRMATION);
    }, [changeScreen, itemsLength]);

    return (
        <div aria-label="Success page" className={s.container}>
            <SuccessMessageConnected />
            {!isSubscriptionItems && !isLuxuryEnabled && (
                <ReorderPopupSuccessPageConnected isOpen={isModalOpen} setVisible={setModalOpen} />
            )}
            {screen === FILL_DR_DETAILS_OR_UPLOAD_FILE && (
                <>
                    <DrDetailsOrUploadFileRedesignItemsConnected isModalOpen={isModalOpen} />
                    <ConfirmButtonConnected />
                    <SendLaterSuccessButtonConnected />
                </>
            )}
        </div>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    isPending: getStatus(store) === 'pending',
    isSubscriptionItems: isOrderContainsSubscriptionItems(store),
    itemsLength: Boolean(getSuccessPageItems(store).length),
    screen: getSuccessScreen(store),
});

export const SuccessContactLensesConnected = connect(mapStateToProps, {
    changeScreen: changeSuccessScreen,
})(SuccessContactLenses);
